// src/firebase.js
// ─────────────────────────────────────────────────────────────
// Replace every VITE_* / REACT_APP_* value with your own keys
// in a .env file at the project root:
//
//   REACT_APP_FB_API_KEY=...
//   REACT_APP_FB_AUTH_DOMAIN=...
//   REACT_APP_FB_PROJECT_ID=...
//   REACT_APP_FB_STORAGE_BUCKET=...
//   REACT_APP_FB_MESSAGING_SENDER_ID=...
//   REACT_APP_FB_APP_ID=...
// ─────────────────────────────────────────────────────────────
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FB_API_KEY,
  authDomain:        process.env.REACT_APP_FB_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FB_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FB_APP_ID,
};

const app  = initializeApp(firebaseConfig);
export const db   = getFirestore(app);
export const auth = getAuth(app);
export default app;
